//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapMutations } from 'vuex'
export default {
  name:'Plasma_Volume',
  data() {
    return {
      defaultJson:{
        "Weight": "体重",
        "Erythrocyte volume": "红细胞比容",
      },
      form:{
        weight:'',
        erythrocyte_volume:'',
      },
      hasScore:false,
      disabled:false,
    }
  },
  created () {
    this.hideLoad()
  },
  methods: {
    ...mapMutations(['hideLoad']),
  },
  computed: {
    /** 计算公式结果 */
    score() {
      let self = this
      let form = JSON.parse(JSON.stringify(self.form))
      let flag = true
      for (const key in form) {
        if (form.hasOwnProperty(key)) {
          if (!form[key]) {
            flag = false
          } else {
            if (form[key]=='---') {
              flag = false
            } else {
              form[key] = Number(form[key])
            }
          }
        }
      }
      if (!flag) {
        self.hasScore = false
        return '...'
      } else {
        // PV=0.065*体重*（1-Hct）
        let result = 0.065 * form.weight * (1 - form.erythrocyte_volume / 100)
        self.hasScore = true
        return String((result*1000).toFixed(0))
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/pages/formulas/Endocrine/Plasma_Volume.vue